exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items{-ms-flex-wrap:nowrap;flex-wrap:nowrap}.ck.ck-toolbar-dropdown .ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", ""]);
